import { combineClasses } from "@/lib/utils";
import styles from "./AuthLogo.module.scss";
import BFCSignIN from "@/assets/svg/LoginPage/BFCSignIN";
import BFCSignUP from "@/assets/svg/LoginPage/BFCSignUP";

interface AuthLogoProps {
  tone?: "light" | "accent";
  className?: string | undefined;
}

const AuthLogo = ({ tone = "accent", className }: AuthLogoProps) => {
  return (
    <div
      aria-label="BFC"
      className={combineClasses(styles.logo, styles[tone], className)}
      role="img"
    >
      <div className={styles.mark}>
        {tone === "light" ? (
          <BFCSignIN aria-hidden="true" focusable="false" />
        ) : (
          <BFCSignUP />
        )}
      </div>
    </div>
  );
};

export default AuthLogo;
